module.exports = __webpack_public_path__ + "static/img/animales_10.205fc103.jpg";